import { SignIn } from '@clerk/react';
import {
  Box,
  Container,
  Stack,
  Typography,
} from '@mui/material';
import { useT } from '../i18n';

export function LoginPage() {
  const t = useT();

  return (
    <Container maxWidth="xs" sx={{ mt: 8 }}>
      <Stack alignItems="center" spacing={2}>
        {/* Navy lockup (mark + wordmark); rendered white on the dark theme. */}
        <Box
          component="img"
          src="/logo-lockup.png"
          alt={t('auth.brand')}
          sx={(theme) => ({
            width: 240,
            height: 'auto',
            filter: theme.palette.mode === 'dark' ? 'brightness(0) invert(1)' : 'none',
          })}
        />
        <Typography variant="body2" color="text.secondary">
          {t('auth.subtitle')}
        </Typography>
      </Stack>
      <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
        <SignIn routing="hash" />
      </Box>
      <Typography variant="caption" display="block" textAlign="center" mt={2} color="text.secondary">
        {t('auth.staffOnly')}
      </Typography>
    </Container>
  );
}
